import { formatKES } from "../../../utils/transactionutils";

export const FundsTransferValidators = {
  amount: (v, disbursementLimits) => {
    if (!v) return "Amount is required";
    if (Number.isNaN(Number(v))) return "Amount must be a number";
    const min = disbursementLimits?.minAmount ?? 10;
    const max = disbursementLimits?.maxAmount ?? 250000;
    if (Number(v) < min) return `Amount must be at least ${formatKES(min)}`;
    if (Number(v) > max) return `Amount must not exceed ${formatKES(max)}`;
    return null;
  },

  selectedPayoutAccountId: (v) => {
    if (!v) return "Please select a payout account";
    return null;
  },
};
